import { render } from "./slim.vue?vue&type=template&id=5665a781"
import script from "./slim.vue?vue&type=script&lang=js"
export * from "./slim.vue?vue&type=script&lang=js"

import "./slim.vue?vue&type=style&index=0&id=5665a781&lang=css"

import exportComponent from "/home/douglas/Rwi/surefooted-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__